export default __webpack_public_path__ + "static/media/hbs-blk-poster-2.8a5eefdf.jpg";